/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.1
 */

import { icons } from '../../../../../../assets';
import { FlexColumnMiddleStyled } from '../../../../../../components/common/Block/Flexbox';
import { ImgStyled } from '../../../../../../components/common/Block/Img';
import { IPageDashboardTranslation } from '../../../../../../modules/internationalization/types';
import { WidgetHelpTitleStyled } from '../../styled/WidgetHelpStyled';
import { WidgetEmptyCircleStyled } from '../../styled/WidgetStyled';
import {
    WidgetSubscriberMaxCostsEmptyLabelStyled,
    WidgetSubscriberMaxCostsEmptyLabelTipsStyled,
} from '../../WidgetSubscribersMaxCosts/styled/widgetSubscriberMaxCostsStyled';

interface IWidgetPaymentHistoryEmptyProps {
    translation: IPageDashboardTranslation;
}

const WidgetPaymentHistoryEmpty = (props: IWidgetPaymentHistoryEmptyProps) => {
    const { translation } = props;
    return (
        <FlexColumnMiddleStyled>
            <WidgetEmptyCircleStyled>
                <ImgStyled
                    className="medium"
                    src={icons.paymentIconMedium}
                />
            </WidgetEmptyCircleStyled>
            <WidgetSubscriberMaxCostsEmptyLabelStyled>
                <WidgetHelpTitleStyled>
                    {translation.widgets.paymentHistory.empty.title}
                </WidgetHelpTitleStyled>
            </WidgetSubscriberMaxCostsEmptyLabelStyled>
            <WidgetSubscriberMaxCostsEmptyLabelTipsStyled>
                {translation.widgets.paymentHistory.empty.helpText}
            </WidgetSubscriberMaxCostsEmptyLabelTipsStyled>
        </FlexColumnMiddleStyled>
    );
};

export default WidgetPaymentHistoryEmpty;
